import { useState } from 'react';
import styles from './Profile.module.css';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import EditKidProfileForm from 'components/profileForm/editKidProfileForm';
import { setKidArchived } from 'services/profileManegement/set-kid-archived';
import { KidsData } from 'modules/profile';
import { setKidDearchived } from 'services/profileManegement/set-kid-dearchived';
import SuccessPopup from 'components/successPopup/successPopup';

interface EditKidProfileProps {
    kidsData: KidsData[];
    onBack: () => void;

}

export default function EmployKidManagment({ kidsData, onBack, }: EditKidProfileProps) {
    const [visibleIndex, setVisibleIndex] = useState<number | null>(null);
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);

    const toggleFormVisibility = (index: number) => {
        setVisibleIndex(visibleIndex === index ? null : index);
    };
    const handelArchivKid = async (id: number) => {
        try {
            await setKidArchived(id ?? null);
            setIsSuccessPopupOpen(true)
        } catch (error) {
            console.error("Fehler bei der Archivierung von Daten:", error);
        }
    };
    const handelDearchivKid = async (id: number) => {
        try {
            await setKidDearchived(id ?? null);
            setIsSuccessPopupOpen(true)
        } catch (error) {
            console.error("Fehler bei der Dearchivierung von Daten:", error);
        }
    };
    const nonArchivedKids = kidsData.filter((kid) => !kid.isArchived);
    const archivedKids = kidsData.filter((kid) => kid.isArchived);
    return (
        <div className={styles.kidsEditForm}>
            {nonArchivedKids.map((kid, index) => (
                <div key={kid.id} className={styles.kidItem}>
                    <div className={styles.kidItemHeade} onClick={() => toggleFormVisibility(index)}>
                        <p>
                            {kid.first_name} {kid.last_name}
                        </p>
                        {visibleIndex === index ? <IoIosArrowUp /> : <IoIosArrowDown />}
                    </div>
                    {visibleIndex === index && (
                        <EditKidProfileForm
                            initialValues={{
                                isArchived: kid.isArchived,
                                id: kid.id,
                                first_name: kid.first_name,
                                last_name: kid.last_name,
                                birth_date: kid.birth_date,
                                country: kid.country,
                                age: kid.age,
                                zip: kid.zip,
                                city: kid.city,
                                allergy_medication: kid.allergy_medication,
                                street: kid.street,
                                note: kid.note,
                            }}
                            buttonOptions={[

                                {
                                    label: "Abbrechen",
                                    onClick: () => { setVisibleIndex(null) },
                                },
                                {
                                    label: "Archivieren",
                                    onClick: () => handelArchivKid(kid.id),
                                },
                                {
                                    label: "Speichern",
                                },
                            ]}
                            onSubmitSuccess={onBack}
                        />

                    )}
                </div>
            ))}


            {archivedKids.length > 0 && (
                <div className={styles.sectionTitle}>
                    <h3>Archiviert</h3>
                    <p> Hier finden Sie die Daten archivierter Kinder.</p>
                </div>
            )}

            {archivedKids.map((kid, index) => (
                <div key={kid.id} className={styles.kidItem}>
                    <div className={styles.kidItemHeade} onClick={() => toggleFormVisibility(index + nonArchivedKids.length)}>
                        <p>
                            {kid.first_name} {kid.last_name}
                        </p>
                        {visibleIndex === index + nonArchivedKids.length ? <IoIosArrowUp /> : <IoIosArrowDown />}
                    </div>
                    {visibleIndex === index + nonArchivedKids.length && (
                        <EditKidProfileForm
                            initialValues={{
                                isArchived: kid.isArchived,
                                id: kid.id,
                                first_name: kid.first_name,
                                last_name: kid.last_name,
                                birth_date: kid.birth_date,
                                country: kid.country,
                                age: kid.age,
                                zip: kid.zip,
                                city: kid.city,
                                allergy_medication: kid.allergy_medication,
                                street: kid.street,
                                note: kid.note,
                            }}
                            buttonOptions={[
                                {
                                    label: "Abbrechen",
                                    onClick: () => { setVisibleIndex(null) },
                                },
                                {
                                    label: "Wiederherstellen",
                                    onClick: () => handelDearchivKid(kid.id),
                                },
                                {
                                    label: "Speichern",
                                },
                            ]}
                            onSubmitSuccess={onBack}
                        />
                    )}
                </div>
            ))}
            <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
                onBack();
                setIsSuccessPopupOpen(false);
            }} />
        </div>
    );
}
